module.exports = __webpack_public_path__ + "assets/8c4eb41bdbae523a58bb23522e1f2036.png";